module.exports = __webpack_public_path__ + "static/media/jingold.f5eecdeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/jingold.png
// module id = 804
// module chunks = 0